var swiper = new Swiper(".js-feature-after-before", {
    slidesPerView: 1.1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        375: {
            slidesPerView: 1.2,
            spaceBetween: 20
        },
        490: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2.7,
            spaceBetween: 20
        },
        1023: {
            slidesPerView: 3,
            spaceBetween: 20
        }
    }
});